import React from 'react'

const SettingsMain = () => {
    return (
        <div className="_nft_settings_main_inner">
            <div className="_nft_pro_settings_title_wrap">
                <h2 className="_nft_pro_settings_title">Profile Settings</h2>
            </div>
            <div className="_nft_pro_settings_top">
                <div className="_nft_pro_settings_top_img_wrap">
                    <img src="assets/img/profile-settings.png" alt="bg" className="_nft_pro_settings_top_img" />
                    <button className="_nft_pro_settings_top_btn">
                        <span className="_nft_pro_settings_top_btn_ic">
                            <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="none" viewBox="0 0 28 29">
                                <path fill="#fff" d="M9.606 15.864a4.556 4.556 0 0 0 4.554 4.554 4.556 4.556 0 0 0 4.555-4.554 4.553 4.553 0 1 0-9.108 0ZM23.97 8.157h-4.904c-.35-1.401-.7-2.802-2.102-2.802h-5.605c-1.401 0-1.752 1.4-2.102 2.802H4.351c-.77 0-1.4.63-1.4 1.401V22.17c0 .77.63 1.401 1.4 1.401H23.97c.771 0 1.402-.63 1.402-1.401V9.558c0-.77-.631-1.4-1.402-1.4Zm-9.81 13.925a6.22 6.22 0 0 1 0-12.436 6.22 6.22 0 0 1 0 12.436Zm9.81-9.721h-2.803V10.96h2.802v1.401Z" />
                            </svg>
                        </span>
                        <span className="_nft_pro_settings_top_btn_txt">
                            Edit Cover
                        </span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default SettingsMain;